import posthog from "posthog-js";

// ============================================================
// Raw per-channel event emitters
// ============================================================
// Thin wrappers around each analytics SDK's global. The TrackingCore.track()
// method fans an event out across these; they're also exported individually for
// the rare case a caller needs to hit a single channel directly.

export function tiktokEvent(event: string, data?: any) {
  (window as any).ttq?.track?.(event, data);
}

export function gtagEvent(event: string, data?: any) {
  (window as any).gtag?.("event", event, data);
}

export function fbqEvent(event: string, data?: any) {
  (window as any).fbq?.("track", event, data);
}

export function gtmEvent(event: string, data?: Record<string, any>) {
  const dataLayer = (window as any).dataLayer;
  if (dataLayer) {
    dataLayer.push({
      event,
      ...data,
    });
  }
}

export function posthogEvent(event: string, data?: Record<string, any>) {
  posthog.capture(event, data);
}

// Generate a unique event ID for deduplication
export function generateEventId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
}
